import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ showLogin = true }) => {
  return (
    <nav className="navbar">
      <img className="navbar-logo" src="/logo-cgl-transparent.png" alt="CGL Multi-services" />
      {showLogin && (
        <Link to="/login" className="navbar-login">Iniciar Sesion</Link>
      )}
    </nav>
  );
};

export default Navbar;
